/**
 * La descripción que alguien escribió en la caja de IA de veltica.com
 * (`/embed/prompt`) antes de tener cuenta.
 *
 * La caja no genera nada: sin sesión no hay a quién cobrarle la IA, y las
 * claves no salen nunca del servidor. Guarda aquí lo escrito —con el negocio y
 * lo que quiere, si lo eligió— y lleva a registrarse; al entrar, el panel abre
 * el asistente con ello y genera ya con cuenta (ver `Home`). Se lee una vez.
 */
import type { WelcomeAnswers } from './welcomeAnswers'

export type PendingPrompt = { prompt: string; brief: WelcomeAnswers | null; savedAt: number }

/** Un día: lo normal es volver en minutos, con el correo de confirmación. */
const MAX_AGE_MS = 24 * 60 * 60 * 1000
const KEY = 'veltica:pending-prompt'

export function savePendingPrompt(prompt: string, brief: WelcomeAnswers | null): boolean {
  try {
    globalThis.localStorage.setItem(KEY, JSON.stringify({ prompt, brief, savedAt: Date.now() }))
    return true
  } catch {
    return false
  }
}

/** Lo guardado, y se borra: abrir el asistente una vez es lo que se pidió. */
export function consumePendingPrompt(): PendingPrompt | null {
  try {
    const raw = globalThis.localStorage.getItem(KEY)
    if (!raw) return null
    globalThis.localStorage.removeItem(KEY)
    const saved = JSON.parse(raw) as PendingPrompt
    if (typeof saved?.prompt !== 'string' || !saved.prompt.trim() || Date.now() - saved.savedAt > MAX_AGE_MS) return null
    return saved
  } catch {
    return null
  }
}
